export default "__VITE_ASSET__2bb8527f__"